import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';
import { sleep } from '@/js/lib/helper/sleep';
import IMenu from '@/js/components/molecules/IMenu.vue';

const KEY = 'close-event-like-balloon';
const TTL = 24 * 86400;

export default /*@__PURE__*/_defineComponent({
  __name: 'eventLikeBalloon',
  props: {
    liked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const isShow = ref(false);
const onHideMenu = () => {
  isShow.value = false;
  setToStorage({ key: KEY, value: true, expirationSeconds: TTL });
};

onMounted(async () => {
  await sleep(2500);
  isShow.value = !getFromStorage({ key: KEY }) && !props.liked;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IMenu, {
    modelValue: isShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShow).value = $event)),
    width: "292",
    onHide: onHideMenu
  }, {
    menu: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode("\n      お気に入りイベントに追加しませんか？", -1),
      _createElementVNode("br", null, null, -1),
      _createTextVNode("\n      開催のお知らせをメールでお届けします。\n    ", -1)
    ])),
    _: 1
  }, 8, ["modelValue"]))
}
}

})